import React, { useState } from 'react';
import dayjs from 'dayjs';
import './CalendarFetchByPeriods.scss';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import Flatpickr from 'react-flatpickr';

function getDaysInMonth(date): number {
  const month = Number(dayjs(date).format('MM'));
  const year = Number(dayjs(date).format('YY'));

  return new Date(year, month, 0).getDate();
}

export const getStartDate = (): dayjs.Dayjs => {
  const dateToSet = dayjs(new Date());
  if (Number(dayjs(dateToSet).format('DD')) < 16) {
    return dateToSet.date(1);
  } else {
    return dateToSet.date(15);
  }
};

export const getEndDate = (): dayjs.Dayjs => {
  const dateToSet = dayjs(new Date());
  if (Number(dayjs(dateToSet).format('DD')) < 16) {
    return dateToSet.date(14);
  } else {
    const daysInThatMonth = getDaysInMonth(dateToSet);
    return dateToSet.date(daysInThatMonth);
  }
};

export function getPeriodByEndDate(endDate): string {
  return Number(dayjs(endDate).format('DD')) < 16 ? '1' : '2';
}
export const CalendarFetchByPeriods = ({
  fetchValues,
  givenStartDate = dayjs(new Date()),
  givenEndDate = dayjs(new Date()),
}) => {
  const [startDate, setStartDate] = useState(dayjs(givenStartDate));
  const [endDate, setEndDate] = useState(dayjs(givenEndDate));

  const changePeriod = (changeInt, endDate, startDate) => {
    const endDayNow = Number(dayjs(endDate).format('DD'));

    if (endDayNow > 16) {
      const newMonth =
        changeInt > 0 ? dayjs(startDate).add(changeInt, 'month') : startDate;
      const fetchStartDate = newMonth.date(1);
      const fetchEndDate = newMonth.date(14);
      setStartDate(fetchStartDate);
      setEndDate(fetchEndDate);

      fetchValues({ fetchStartDate, fetchEndDate });
    } else {
      const newMonth =
        changeInt < 0 ? dayjs(startDate).add(changeInt, 'month') : startDate;
      const daysInThatNewMonth = getDaysInMonth(newMonth);

      const fetchStartDate = newMonth.date(15);
      const fetchEndDate = newMonth.date(daysInThatNewMonth);
      setStartDate(fetchStartDate);
      setEndDate(fetchEndDate);

      fetchValues({ fetchStartDate, fetchEndDate });
    }
  };

  return (
    <div className="calendarfetchByPeriods">
      <div className="calendarRow">
        <div className="choosePeriod">
          <div className="spaceText">Choose period:</div>
          <div className="positionChooser">
            <FaChevronLeft
              onClick={() => changePeriod(-1, endDate, startDate)}
            />
            <div className="spaceText">
              Period: {getPeriodByEndDate(endDate)}
            </div>
            <FaChevronRight
              onClick={() => changePeriod(1, endDate, startDate)}
            />
          </div>
        </div>

        <div className="positionToFromDates">
          <div className="positionDate">
            <div className="text">From</div>
            <Flatpickr
              disabled
              onChange={selectedDates => setStartDate(dayjs(selectedDates[0]))}
              value={dayjs(startDate).format('DD. MMM YY')}
              options={{
                dateFormat: 'd. M y',
                shorthandCurrentMonth: true,
                locale: { firstDayOfWeek: 1 },
              }}
              render={(props, ref) => (
                <input
                  style={{ cursor: 'not-allowed' }}
                  className={'form-control'}
                  disabled
                  type="text"
                  ref={ref}
                />
              )}
            />
          </div>

          <div className="positionDate">
            <div className="text">To</div>
            <Flatpickr
              disabled
              onChange={selectedDates => setEndDate(dayjs(selectedDates[0]))}
              value={dayjs(endDate).format('DD. MMM YY')}
              options={{
                dateFormat: 'd. M y',
                shorthandCurrentMonth: true,
                locale: { firstDayOfWeek: 1 },
              }}
              render={(props, ref) => (
                <input
                  style={{ cursor: 'not-allowed' }}
                  className={'form-control'}
                  disabled
                  type="text"
                  ref={ref}
                />
              )}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
